import React, { useState, useEffect, useRef } from 'react';

const TYPING_SPEED = 55;
const ERASE_SPEED = 40;
const INITIAL_DELAY = 300;
const THINKING_DELAY = 1050;

export default function TypingHero() {
  const [text, setText] = useState('');
  const [showCursor, setShowCursor] = useState(false);
  const [cursorBlink, setCursorBlink] = useState(false);
  const rafRef = useRef();

  useEffect(() => {
    let cancelled = false;

    const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

    const typeText = async (str, base = '') => {
      for (let i = 0; i < str.length; i++) {
        if (cancelled) return;
        base += str[i];
        setText(base);
        await sleep(TYPING_SPEED);
      }
      return base;
    };

    const eraseChars = async (current, count) => {
      for (let i = 0; i < count; i++) {
        if (cancelled) return current;
        current = current.slice(0, -1);
        setText(current);
        await sleep(ERASE_SPEED);
      }
      return current;
    };

    const run = async () => {
      // Phase 1: show cursor, wait
      setShowCursor(true);
      setCursorBlink(true);
      await sleep(INITIAL_DELAY);
      if (cancelled) return;

      // Phase 2: type "WRITE YOUR STORY"
      setCursorBlink(false);
      const typed = await typeText('WRITE YOUR STORY');
      if (cancelled) return;

      // Cursor blinks while "thinking"
      setCursorBlink(true);
      await sleep(THINKING_DELAY);
      if (cancelled) return;

      // Phase 3: erase "STORY", type "UNIVERSE"
      setCursorBlink(false);
      const after = await eraseChars(typed, 'STORY'.length);
      if (cancelled) return;
      await typeText('UNIVERSE', after);
      if (cancelled) return;

      // Phase 4: add period, keep cursor blinking
      setText(after + 'UNIVERSE.');
      setCursorBlink(true);
    };

    run();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="select-none mb-4" style={{ minHeight: '2.5rem' }}>
      <span
        style={{
          fontFamily: "'Inter', 'Segoe UI', sans-serif",
          fontWeight: 200,
          fontSize: '0.975rem',
          letterSpacing: '0.18em',
          color: '#ffffff',
          whiteSpace: 'pre',
        }}
      >
        {text}
      </span>
      {showCursor && (
        <span
          style={{
            display: 'inline-block',
            width: '1.5px',
            height: '1.4em',
            backgroundColor: '#ffffff',
            marginLeft: '2px',
            verticalAlign: 'baseline',
            animation: cursorBlink ? 'cursorBlink 530ms step-end infinite' : 'none',
            opacity: 1,
          }}
        />
      )}
      <style>{`
        @keyframes cursorBlink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0; }
        }
      `}</style>
    </div>
  );
}
